var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container"},[_c('Spin',{attrs:{"size":"large","fix":""}},[_vm._v("微信认证中...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }